import { s } from '../lib/dom';

/**
 * The FunSource atom mark. Uses SMIL animateTransform so rotation
 * pivots correctly around the nucleus.
 */
export function createAtomMark(opts: { size?: number; className?: string } = {}): SVGSVGElement {
  const size = opts.size ?? 320;
  const svg = s('svg', {
    xmlns: 'http://www.w3.org/2000/svg',
    viewBox: '-100 -110 200 220',
    width: size,
    height: Math.round(size * (220 / 200)),
    role: 'img',
    'aria-label': 'FunSource mark',
    class: opts.className ?? '',
  });

  svg.append(
    s('circle', { r: 76, fill: 'rgba(255,153,51,0.05)' }),
    s('circle', { r: 60, fill: 'none', stroke: 'rgba(255,255,255,0.08)', 'stroke-width': 1 }),
  );

  const orbits = s('g');
  orbits.append(
    s('ellipse', { rx: 60, ry: 22, fill: 'none', stroke: 'rgba(255,255,255,0.55)', 'stroke-width': 1.4 }),
    s('ellipse', { rx: 60, ry: 22, fill: 'none', stroke: 'rgba(255,255,255,0.55)', 'stroke-width': 1.4, transform: 'rotate(60)' }),
    s('ellipse', { rx: 60, ry: 22, fill: 'none', stroke: 'rgba(255,255,255,0.55)', 'stroke-width': 1.4, transform: 'rotate(-60)' }),
  );
  orbits.append(s('animateTransform', {
    attributeName: 'transform', type: 'rotate',
    from: '0', to: '360', dur: '60s', repeatCount: 'indefinite',
  }));

  const electrons = s('g');
  const e = (cx: number, cy: number, cls: 'sa' | 'wh' | 'gr') => {
    const palette = { sa: '#FF9933', wh: '#ffffff', gr: '#138808' };
    return s('circle', {
      cx, cy, r: 7,
      fill: palette[cls],
      stroke: '#06038D',
      'stroke-width': cls === 'wh' ? 1.2 : 0,
    });
  };
  electrons.append(
    e(60, 0, 'sa'),
    e(30, 51.96, 'wh'),
    e(-30, 51.96, 'gr'),
    e(-60, 0, 'sa'),
    e(-30, -51.96, 'wh'),
    e(30, -51.96, 'gr'),
  );
  electrons.append(s('animateTransform', {
    attributeName: 'transform', type: 'rotate',
    from: '360', to: '0', dur: '28s', repeatCount: 'indefinite',
  }));

  svg.append(orbits, electrons);

  svg.append(
    s('circle', { r: 14, fill: 'rgba(255,153,51,0.18)' }),
    s('circle', { r: 9, fill: '#06038D' }),
  );

  return svg;
}

/** Small monochrome mark for nav/footer. */
export function createBrandGlyph(size = 28): SVGSVGElement {
  const svg = s('svg', { xmlns: 'http://www.w3.org/2000/svg', viewBox: '-32 -32 64 64', width: size, height: size, 'aria-hidden': 'true' });
  svg.append(
    s('ellipse', { rx: 22, ry: 9, fill: 'none', stroke: '#FF9933', 'stroke-width': 2 }),
    s('ellipse', { rx: 22, ry: 9, fill: 'none', stroke: '#eef7ff', 'stroke-width': 2, transform: 'rotate(60)' }),
    s('ellipse', { rx: 22, ry: 9, fill: 'none', stroke: '#138808', 'stroke-width': 2, transform: 'rotate(-60)' }),
    s('circle', { r: 3.5, fill: '#06038D', stroke: '#eef7ff', 'stroke-width': 1 }),
  );
  return svg;
}
